import React from 'react';
import { heroData, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="relative min-h-[100vh] md:min-h-[85vh] overflow-hidden">
      {/* Background Images - Responsive */}
      <div className="absolute inset-0">
        {/* Desktop Image - adjusted positioning */}
        <div
          className="hidden md:block absolute inset-0 bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url('/images/hero-banner-desktop.png')`,
            backgroundPosition: 'center 30%'
          }}
        />
        {/* Mobile Image - adjusted positioning */}
        <div
          className="md:hidden absolute inset-0 bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url('/images/hero-banner-mobile.png')`,
            backgroundPosition: 'center center'
          }}
        />
      </div>

      {/* Lighter dark overlay */}
      <div className="absolute inset-0 bg-[#2a2523]/40" />

      {/* Lighter gradient from left */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#2a2523]/80 via-[#2a2523]/40 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 pt-20 pb-12 md:pt-32 md:pb-16 lg:pt-40 lg:pb-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#2a2523]/80 backdrop-blur border border-[#c9a962]/30 px-4 py-2 rounded-full mb-8">
            <div className="w-2 h-2 bg-[#c9a962] rounded-full animate-pulse" />
            <span className="text-neutral-300 text-sm">{heroData.badge}</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white leading-tight mb-8">
            {heroData.headline.split(' ').map((word, i) => (
              <span key={i} className={word === 'sociedade' || word === 'sócios' ? 'text-[#c9a962]' : ''}>
                {word}{' '}
              </span>
            ))}
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-neutral-200 leading-relaxed max-w-lg mb-10">
            {heroData.subheadline}
          </p>

          {/* CTA */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-emerald-500/25"
          >
            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>

          {/* Trust indicators */}
          <div className="flex items-center gap-6 mt-10">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-emerald-500 rounded-full" />
              <span className="text-neutral-300 text-sm">Atendimento personalizado</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient - very subtle transition */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-neutral-50/60 to-transparent" />
    </section>
  );
};

export default HeroSection;
